import React, {useEffect, useState} from "react";
import {Collapse, Table} from "antd";
import "./parseResultTable.css";
import {ParsedField, ParsedItem} from "../../../api/extract";
const uuid = require('react-uuid');

const {Panel} = Collapse;

interface ResultItemTableProps {
    data: Record<string, ParsedField>,
}

export function ResultItemTable({data}: ResultItemTableProps) {
    const columns = [
        {title: "Название", dataIndex: "name", key: "name", width: "200px"},
        {title: "Значение", dataIndex: "value", key: "value", className: "col-value"},
        {title: "Ошибка", dataIndex: "error", key: "error", className: "col-error"},
    ]

    const [formatted, setFormatted] = useState<any[]>([]);
    useEffect(() => {
        const ret = [];
        for (const key in data) {
            ret.push({
                "name": key,
                "is_valid": data[key].is_valid,
                "value_from_dom": data[key].value_from_dom,
                "value": data[key].value,
                "error": data[key].error,
            })
        }

        setFormatted(ret);
    }, [data])

    return (
        <Table
            rowKey={() => uuid()}
            columns={columns}
            dataSource={formatted}
            pagination={false}
            rowClassName={(record) => !record.is_valid ? "row-error" : ""}
            // scroll={{x: 1500}}
        />
    )
}

interface ParseResultsProps {
    items: ParsedItem[] | null
}

export function ParseResults({items}: ParseResultsProps) {
    if (!items) {
        return <></>
    }

    return (
        <Collapse defaultActiveKey={['0']}>
            {
                items.map((item, idx) =>
                    <Panel className={`${!item.is_valid ? "panel-error" : ""}`}
                           header={`Объект ${idx + 1} ${!item.is_valid ? "(ошибка)" : ""}`} key={idx}>
                        <ResultItemTable data={item.fields} key={idx}/>
                    </Panel>
                )
            }
        </Collapse>
    )
}
